export const TENANT_ADMIN = "TENANT_ADMIN";
export const TENANT_WAITER = "TENANT_WAITER";
